<template>

    <div class="galaxy::common-canvas-editor-canvas-FloatingPanel tw-shadow-xl tw-absolute" :style="{ width: width + 'px' }">

        <div class="tw-rounded-t-lg tw-text-white tw-flex tw-items-center top">

            <div class="tw-mr-auto tw-ml-5 title">{{ title }}</div>

            <button class="tw-border-0 tw-rounded-full tw-text-white tw-w-5 tw-h-5 tw-text-xs tw-ml-3 tw-mr-3 tw-items-center close" @click="close">
                <i class="fa fa-times"></i>
            </button>

        </div>

        <div class="tw-bg-white tw-rounded-b-lg tw-py-1 content">

            <slot />

            <div class="tw-m-5 actions" v-if="$slots['actions'] || $slots['actionsExtra'] || saveable">

                <slot name="actions" />

                <div v-if="!$slots['actions']">

                    <slot name="actionsExtra" />

                    <button v-if="saveable" class="hover:tw-bg-green-400 tw-bg-green-500 tw-border-0 tw-text-sm tw-font-bold tw-px-4 tw-py-2 tw-rounded tw-text-white" @click="save">
                        <i class="fas fa-check tw-mr-1"></i>Opslaan
                    </button>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

    export default {

        inject: [
            '$pageComponent',
            'options',
        ],

        props: {
            title: {
                type: String,
                default: 'Instellingen',
            },
            width: {
            	type: Number,
                default: 400,
            },
            saveable: {
                type: Boolean,
                default: true,
            },
        },

        methods: {

            close()
            {
                this.$pageComponent().selection.setSelection(null);
            },

            save()
            {
                // Close after save.
                this.$pageComponent().state.$once('newHtml', html => this.close());

                // @ugly We asume AbstractPanel is above us.
                this.$parent.save();
            },

        },

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-editor-canvas-FloatingPanel {
        left: 25px;
        top: 25px;

        @import './../../../../../../../../sass/common/canvas/editor/canvas/document/adminTemplate';

        .top {
            background: #3899ec;
            // cursor: move; TODO Implement dragging panel.
            padding-bottom: 10px;
            padding-top: 10px;

            // Needed since a block css targets .title
            .title {
                font-size: 1rem;
            }

            .close {
                background: #2b81cb;
                outline: none !important;
            }
        }

        .content {

            &::v-deep {

                // TODO Right place?
                input::placeholder {
                    opacity: .5;
                }

            }

        }

        .actions {
            font-size: 0;
        }

    }

</style>